import React from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import OpenapiRpcMain from './components/home/MainPage';

const App = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={OpenapiRpcMain} />
      </Switch>
    </Router>
  );
};
export default App;
